<script>
  import { TweenMax, Power1 } from 'gsap'
  import { dataTransTime } from '@/lib/consts'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import Percentage from '@/components/report/content/Percentage'

  export default {
    name: 'GraphFragMixin',
    mixins: [ StateMixin ],
    props: {
      percentSize: Number,
      active: Boolean,
      indOverride: null,
      label: { type: Object, required: true },
      target: { type: Number, required: true }
    },
    data () {
      return {
        num: this.active ? this.target : 0
      }
    },
    computed: {
      fontSize () {
        return typeof this.percentSize === 'undefined' ? 72 : this.percentSize
      }
    },
    watch: {
      active ( val ) {
        this.handleChange( val )
      },
      target ( val ) {
        this.handleChange( val, (dataTransTime / 2) )
      }
    },
    methods: {
      handleChange ( val, time = dataTransTime, key = 'num' ) {
        TweenMax.to( this, time, {
          [ key ]: val ? this.target : 0,
          ease: Power1.easeInOut
        } )
      }
    },
    mounted () {
      if ( this.active ) this.handleChange( true )
    },
    components: {
      Percentage
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .graphs-wrap {
    margin-bottom : rem(60);
  }
</style>



// WEBPACK FOOTER //
// src/components/report/mixins/GraphFragMixin.vue